import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { getToken } from '../../../services/auth';

const useStatusSnapshot = (inicialDate, finalDate) => {
  const [snapshot, setSnapshot] = useState({ rows: [], refresh: true, error: false });
  const requestRef = useRef(null);

  const cancelRequest = useCallback(() => {
    const source = requestRef.current;
    requestRef.current = null;
    if (source) source.cancel();
  }, []);

  const reload = useCallback(() => {
    cancelRequest();
    const source = axios.CancelToken.source();
    requestRef.current = source;
    setSnapshot({ rows: [], refresh: true, error: false });

    axios.get(`${process.env.REACT_APP_WAS_KEY}/notas/status-snapshot`, {
      headers: { Authorization: `Bearer ${getToken()}` },
      cancelToken: source.token,
      params: { inicialDate, finalDate, state: 'ALL' },
      paramsSerializer: (params) => qs.stringify(params, { encode: false })
    }).then((res) => {
      if (requestRef.current !== source) return;
      setSnapshot({ rows: Array.isArray(res.data) ? res.data : [], refresh: false, error: false });
    }).catch((err) => {
      if (requestRef.current !== source) return;
      setSnapshot({ rows: [], refresh: false, error: !axios.isCancel(err) });
    });
  }, [cancelRequest, inicialDate, finalDate]);

  useEffect(() => {
    reload();
    return cancelRequest;
  }, [reload, cancelRequest]);

  return { ...snapshot, reload };
};

export default useStatusSnapshot;
